// extracted by mini-css-extract-plugin
export default {"wrapper":"Pill_wrapper__E7oZ2","active":"Pill_active__iNEgX","inactive":"Pill_inactive__N7L0P"};